module.exports = __webpack_public_path__ + "media/images/awards/top_arrow-331f51b8bab5b59c2a1a748a0b3b0d59.png";